import { Dom } from 'main.core';
import { Loader } from 'main.loader';
import { AnalyticsEventType } from 'b24network.component.useractions';

export class QrCode extends BX.Network.Component
{
	constructor(parameters)
	{
		super(parameters, { autoUpdate: true });

		this.domCache = null;
		this.qrCodeImage = null;
		this.loader = null;
		this.nodeId = 'b24network-auth-qrcode';
		this.pullUnsubscribe = null;
	}

	description()
	{
		return {
			text: {},
			pullConfig: {
				type: Object,
			},
			siteId: {
				type: String,
			},
			uniqueId: {
				type: String,
			},
			channelTag: {
				type: String,
			},
			showBackButton: {
				type: Boolean,
				defaultValue: false,
			},
			showRememberButton: {
				type: Boolean,
				defaultValue: false,
			},
			remember: {
				type: Boolean,
				defaultValue: true,
			},
			allowRedirect: {
				type: Boolean,
				defaultValue: true,
			},
		};
	}

	localization()
	{
		return {
			B24NET_QRCODE_TITLE1: BX.message('B24NET_QRCODE_TITLE1'),
			B24NET_QRCODE_TITLE2: BX.message('B24NET_QRCODE_TITLE2'),
			B24NET_QRCODE_GO_BACK: BX.message('B24NET_QRCODE_GO_BACK'),
			B24NET_AUTH_PASSWORD_REMEMBER: BX.message('B24NET_AUTH_PASSWORD_REMEMBER'),
		};
	}

	render()
	{
		if (!this.domCache)
		{
			this.domCache = Dom.create('div', {
				attrs: {
					class: 'b24-network-auth-slider-qr',
				},
				html: Mustache.render(
					`
						<div class="b24-network-auth-slider-qr-header">
												<span class="b24-network-auth-slider-qr-header-top">{{{messages.B24NET_QRCODE_TITLE1}}}</span>
												<span class="b24-network-auth-slider-qr-header-bottom">{{{messages.B24NET_QRCODE_TITLE2}}}</span>
											</div>
											<div class="b24-network-auth-slider-qr-icon" data-role="b24-network-auth-slider-qr-icon">
												<div class="b24-network-auth-slider-qr-icon-status --loading" data-role="b24-network-auth-slider-qr-icon-loader"></div>
												<div class="b24-network-auth-slider-qr-icon-status --success"></div>
												<div class="b24-network-auth-slider-qr-icon-img" id="{{{nodeId}}}"></div>
											</div>
											{{#showRememberButton}}
											<div class="b24-network-auth-form-field-checkbox">
												<div class="b24-network-auth-form-field-checkbox-inner">
													<input class="b24-network-auth-form-field-check" type="checkbox" id="remember" checked="checked">
													<label for="remember" class="b24-network-auth-form-field-text b24-network-auth-form-field-text-label">
														{{{messages.B24NET_AUTH_PASSWORD_REMEMBER}}}
													</label>
												</div>
											</div>
											{{/showRememberButton}}
											{{#showBackButton}}
											<div class="b24-network-auth-form-btn-block">
												<button data-role="b24-network-auth-slider-qr-back" class="ui-btn ui-btn-md ui-btn-light-border ui-btn-round b24-network-auth-form-btn" type="button">{{{messages.B24NET_QRCODE_GO_BACK}}}</button>
											</div>
											{{/showBackButton}}
					`,
					{
						messages: this.$localization,
						nodeId: this.nodeId,
						showBackButton: this.$data.showBackButton,
						showRememberButton: this.$data.showRememberButton,
					},
				),
			});
			BX.bind(
				this.domCache.querySelector('.ui-btn'),
				'click',
				this.onBackButtonClick.bind(this),
			);
			BX.bind(
				this.domCache.querySelector('#remember'),
				'click',
				this.onRememberClick.bind(this),
			);
		}

		return this.domCache;
	}

	onBackButtonClick()
	{
		this.callEvent('cancel');
		this.unsubscribePullEvent();
	}

	onRememberClick(event)
	{
		this.$data.remember = event.target.checked;
	}

	onAfterUpdate()
	{
		if (!this.qrCodeImage)
		{
			this.qrCodeImage = this.createQrCodeImage();
			this.subscribePullEvent();
		}

		if (!this.loader)
		{
			this.loader = new Loader({
				target: this.domCache.querySelector('[data-role="b24-network-auth-slider-qr-icon-loader"]'),
				size: 150,
			});
		}
	}

	createQrCodeImage()
	{
		const text = this.$data.text ?? `https://b24.to/a/${this.$data.siteId}/${this.$data.uniqueId}/${this.$data.channelTag}/`;

		return new QRCode(this.nodeId, {
			text,
			width: 220,
			height: 220,
			colorDark: '#000000',
			colorLight: '#ffffff',
		});
	}

	subscribePullEvent()
	{
		if (this.$data.pullConfig)
		{
			const Pull = new BX.PullClient();
			this.pullUnsubscribe = Pull.subscribe({
				moduleId: 'main',
				command: 'qrAuthorize',
				callback: (params) => {
					if (params.token)
					{
						this.showLoader();
						BX.ajax.runAction(
							'main.qrcodeauth.authenticate',
							{
								data: {
									token: params.token,
									remember: this.$data.remember ? 1 : 0,
								},
							},
						).then((response) => {
							if (response.status === 'success')
							{
								this.markAsSuccess();
								const redirectUrl = (this.$data.allowRedirect && typeof params.redirectUrl === 'string' && params.redirectUrl !== '')
									? params.redirectUrl
									: null
								;
								if (redirectUrl && BX.Network.hasOwnProperty('Analytics') && typeof URL === 'function')
								{
									const url = new URL(redirectUrl);
									const analytics = BX.Network.Analytics.getInstance();
									if (analytics)
									{
										analytics.registerEvent(AnalyticsEventType.QR_CODE_AUTH_SUCCESS, {
											portal_name: url.hostname,
										});
									}
								}

								window.location = (
									redirectUrl || window.location
								);
							}
							else
							{
								this.hideLoader();
							}
						});
					}
				},
			});
			Pull.start(this.$data.pullConfig);
		}
	}

	unsubscribePullEvent()
	{
		if (this.pullUnsubscribe)
		{
			this.pullUnsubscribe();
			this.pullUnsubscribe = null;
		}
	}

	showLoader()
	{
		if (this.loader)
		{
			this.loader.show();
		}

		if (this.domCache)
		{
			this.domCache.querySelector('[data-role="b24-network-auth-slider-qr-icon"]').classList.add('--loading');
			if (this.$data.showBackButton)
			{
				this.domCache.querySelector('[data-role="b24-network-auth-slider-qr-back"]').classList.add('b24-network-auth-form-btn-hide');
			}

			if (this.$data.showRememberButton)
			{
				this.domCache.querySelector('[data-role="b24-network-auth-slider-qr-back"]').classList.add('b24-network-auth-form-btn-hide');
			}
		}
	}

	hideLoader()
	{
		if (this.loader)
		{
			this.loader.hide();
		}

		if (this.domCache)
		{
			this.domCache.querySelector('[data-role="b24-network-auth-slider-qr-icon"]').classList.remove('--loading');
			if (this.$data.showBackButton)
			{
				this.domCache.querySelector('[data-role="b24-network-auth-slider-qr-back"]').classList.remove('b24-network-auth-form-btn-hide');
			}
		}
	}

	markAsSuccess()
	{
		if (this.loader)
		{
			this.loader.hide();
		}

		if (this.domCache)
		{
			const qrIcon = this.domCache.querySelector('[data-role="b24-network-auth-slider-qr-icon"]');
			qrIcon.classList.remove('--loading');
			qrIcon.classList.add('--success');
		}
	}
}

export class QrCodeButton extends BX.Network.Component
{
	constructor(parameters)
	{
		super(parameters, { autoUpdate: true });

		this.domCache = null;
	}

	localization()
	{
		return {
			B24NET_QRCODE_LOGIN_BY_QRCODE: BX.message('B24NET_QRCODE_LOGIN_BY_QRCODE'),
		};
	}

	render()
	{
		if (!this.domCache)
		{
			this.domCache = Dom.create('div', {
				attrs: {
					class: 'b24-network-auth-form-qr-link',
				},
				events: {
					click: () => this.callEvent('click', []),
				},
				html: Mustache.render(
					'<div class="b24-network-auth-form-qr-icon"></div><div class="b24-network-auth-form-qr-text">{{{buttonText}}}</div>',
					{
						buttonText: this.$localization.B24NET_QRCODE_LOGIN_BY_QRCODE,
					},
				),
			});
		}

		return this.domCache;
	}
}
